import { render, staticRenderFns } from "./SuketIgdPage.vue?vue&type=template&id=5eeea8b2&scoped=true&"
import script from "./SuketIgdPage.vue?vue&type=script&lang=ts&"
export * from "./SuketIgdPage.vue?vue&type=script&lang=ts&"
import style0 from "./SuketIgdPage.vue?vue&type=style&index=0&id=5eeea8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeea8b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VBadge,VBtn,VCard,VDivider,VIcon,VProgressCircular,VSpacer,VTab,VTabItem,VTabs})
